import { HttpParams } from "@capacitor/core";
import { HttpMethods, sendRequest } from "../util/ApiHelper";

const CONTROLLER_NAME = "EquipmentMasters";

export const getEquipment = async (params: HttpParams) => {
  return await sendRequest(HttpMethods.GET, `${CONTROLLER_NAME}/Get`, undefined, params);
};

export const getEquipmentUdvList = async (equipment: string) => {
  return await sendRequest(HttpMethods.GET, `EquipmentUserValues/GetDataForEquipment`, undefined, {
    equipment,
    includeTranslation: "false",
  });
};
